import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
import HeaderNotification from "./HeaderNotification";
import HeaderMessage from "./HeaderMessage";
import NameDisplay from "./NameDisplay";
import useUserStore from "../zustand-stores/UserStore";
import { useGetProfile } from "../Controllers/UserProfileController";
import { useGetLevelDetails } from "../Controllers/DashboardController";
import HeaderLeftUser from "./User/HeaderLeftUser";

export default function Header({ onSidebarToggle }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { user } = useUserStore();
  // const { data: levelDetails } = useGetLevelDetails();

  const { data: profileData } = useGetProfile();

  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdownToggle = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  const toggleExtended = (e) => {
    e.stopPropagation();
    onSidebarToggle();
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const searchInput = (
    <input
      className="header-search text-caption-c2"
      type="text"
      placeholder="Search..."
    />
  );
  return (
    <header className="empowered-header">
      <div className="header-content-wrapper">
        <div className="header-left-container">
          <img
            alt="image-alt"
            className="sidebar-toggle"
            src="/icons/menu.svg"
            onClick={toggleExtended}
          />
          {!isMobile && searchInput}

          <div className="header-icons-container">
            <HeaderMessage
              isDropdownVisible={openDropdown === "message"}
              toggleDropdown={() => handleDropdownToggle("message")}
            />
            <HeaderNotification
              isDropdownVisible={openDropdown === "notification"}
              toggleDropdown={() => handleDropdownToggle("notification")}
            />
          </div>
        </div>
        <HeaderLeftUser />
      </div>
      <div className="search-input-small-devices">
        {isMobile && searchInput}
      </div>
    </header>
  );
}
